export const getBusinessAuditTrailsUrl = () => 'business/audit_trails';
